module.exports = __webpack_public_path__ + "img/满天星学堂.28ab62e9.jpg";